<template>
    <div>
        <div class="card" v-if="pageWidth>1000">
            <div class="situation">
                <!-- 简介 -->
                <div class="radio">
                    <div class="text animate__animated animate__fadeInLeft">
                        <h2 class="title">02 <span>巡天M1多维频谱测绘系统</span></h2>
                        <p style="text-indent: 2em;">
                            巡天M1型多维频谱测绘系统是通过无人机平台搭载频谱感知载荷，将看不见、摸不着的无线电频谱从空间、时间、频率、能量多个维度融合分析，结合先进的算法平台和三维地理可视化技术，动态展示频谱信息。为电磁环境的管控提供直观化、流程化、智能化的解决方案，广泛应用于空间频谱数据采集、无线网络规划优化和重大活动用频保障等领域。
                        </p>
                    </div>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/cehui/cehui.png" alt="">
                        <p>巡天M1多维频谱测绘系统</p>
                    </div>
                </div>

                <!-- 技术要点 -->
                <div class="text technicalPoints">
                    <h3 class="title"><span>产品特色</span></h3>
                    <div>
                        <h4>多维度</h4>
                        <p>从立体空间、时间、频率、场强能量等维度进行频谱数据采集与分析，呈现更加全面、完整的电磁频谱态势信息。</p>
                    </div>
                    <div>
                        <h4>高效率</h4>
                        <p>采用无人机作为载具平台，能够对复杂地形进行快速、灵活高效地进行测绘作业。</p>
                    </div>
                    <div>
                        <h4>低成本</h4>
                        <p>使用无人机减少了对现场操作人员专业能力的要求，降低了学习成本。此外无需建设地面监测站，节约建设和维护成本。</p>
                    </div>
                </div>
            </div>
            <!-- 产品形态 -->
            <div class="text productForm" ref="text">
                <h3 class="title"><span>产品形态</span></h3>
                <div class="device">
                    <div>
                        <img src="@/assets/solution/cehui/xingtai1.png" alt="">
                        <h4>无人机频谱监测</h4>
                        <p>利用无人机搭载频谱监测设备，可以对较大范围的区域进行频谱监测，实现快速、高效的监测任务。</p>
                    </div>
                    <div>
                        <img src="@/assets/solution/cehui/xingtai2.png" alt="">
                        <h4>固定台站式频谱监测</h4>
                        <p>
                            在固定位置设置专门的频谱监测台站，可以持续监测特定区域的频谱使用情况，提供长期的监测数据支持。</p>
                    </div>
                </div>
                <!--          </div>-->
                <div>
                    <h3 class="title"><span>应用场景</span></h3>
                    <div class="scenario">
                        <div ref="text">
                            <div>
                                <h4>电信频谱管理</h4>
                                <p>
                                    无线电监测可以用于监测和管理无线电频谱的使用情况，确保频谱资源的合理分配和有效利用。通过监测无线电信号强度、频率占用情况等数据，可以帮助电信管理机构进行频段规划和频谱分配，避免频谱干扰和冲突。</p>
                            </div>
                            <div>
                                <h4>无线电干扰监测</h4>
                                <p>
                                    无线电监测可以用于检测和识别无线电信号的干扰源。当出现无线电干扰时，通过监测信号的频率、强度、调制方式等特征，可以确定干扰源的位置和类型，及时采取干扰抑制措施，保障正常通信服务的稳定性和可靠性。</p>
                            </div>
                            <div>
                                <h4>电磁环境监测</h4>
                                <p>
                                    无线电监测可以用于对电磁环境进行监测和评估。通过对周围环境中的无线电信号进行监测，可以得到电磁辐射强度、频率分布等数据，评估电磁辐射对人体健康和环境的影响，为相关政策制定和环境保护提供科学依据。</p>
                            </div>
                            <div>
                                <h4>无线电通信安全</h4>
                                <p>
                                    无线电监测可以用于保障无线电通信的安全性。通过监测无线电信号的频谱活动情况，可以发现非法窃听、窃取信息等安全威胁，及时采取对策，防止信息泄露和通信被攻击。</p>
                            </div>
                            <div>
                                <h4>边境管控与执法</h4>
                                <p>
                                    无线电监测可以用于边境管控和执法行动。通过监测边境地区的无线电信号，可以发现非法越境、走私、通信黑点等违法活动，协助执法部门加强边境安全管理和打击犯罪行为。</p>
                            </div>
                        </div>

                        <div class="image_box" ref="img">
                            <img src="@/assets/solution/cehui/radio1.png" alt="">
                            <img src="@/assets/solution/cehui/radio2.png" alt="">
                            <img src="@/assets/solution/cehui/radio3.png" alt="">
                            <img src="@/assets/solution/cehui/radio4.png" alt="">
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="card" v-else>
            <div class="situation">
                <div class="text animate__animated animate__fadeInLeft">
                    <h2 class="title">02 <span>巡天M1多维频谱测绘系统</span></h2>
                    <p style="text-indent: 2em;">
                        巡天M1型多维频谱测绘系统是通过无人机平台搭载频谱感知载荷，将看不见、摸不着的无线电频谱从空间、时间、频率、能量多个维度融合分析，结合先进的算法平台和三维地理可视化技术，动态展示频谱信息。为电磁环境的管控提供直观化、流程化、智能化的解决方案，广泛应用于空间频谱数据采集、无线网络规划优化和重大活动用频保障等领域</p>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/solution/cehui/cehui.png" alt="">
                        <p>巡天M1多维频谱测绘系统</p>
                    </div>

                    <div class="technicalPoints">
                        <h3 class="title"><span>技术要点</span></h3>
                        <div>
                            <h4>多维度</h4>
                            <p>
                                从立体空间、时间、频率、场强能量等维度进行频谱数据采集与分析，呈现更加全面、完整的电磁频谱态势信息。</p>
                        </div>
                        <div>
                            <h4>高效率</h4>
                            <p>
                                采用无人机作为载具平台，能够对复杂地形进行快速、灵活高效地进行测绘作业。</p>
                        </div>
                        <div>
                            <h4>低成本</h4>
                            <p>
                                使用无人机减少了对现场操作人员专业能力的要求，降低了学习成本。此外无需建设地面监测站，节约建设和维护成本。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="compose">
                <div class="text" ref="text">
                    <h3 class="title"><span>产品形态</span></h3>
                    <div>
                        <h4>无人机频谱监测</h4>
                        <p>利用无人机搭载频谱监测设备，可以对较大范围的区域进行频谱监测，实现快速、高效的监测任务。
                        </p>
                        <div class="img">
                            <img src="@/assets/solution/cehui/xingtai1.png" alt="">
                            <p>无人机频谱监测</p>
                        </div>
                        <h4>固定台站式频谱监测</h4>
                        <p>
                            在固定位置设置专门的频谱监测台站，可以持续监测特定区域的频谱使用情况，提供长期的监测数据支持。</p>
                        <div class="img">
                            <img src="@/assets/solution/cehui/xingtai2.png" alt="">
                            <p>固定台站式频谱监测</p>
                        </div>
                    </div>
                    <h3 class="title"><span>应用场景</span></h3>
                    <div>
                        <h4>电信频谱管理</h4>
                        <p>
                            无线电监测可以用于监测和管理无线电频谱的使用情况，确保频谱资源的合理分配和有效利用。通过监测无线电信号强度、频率占用情况等数据，可以帮助电信管理机构进行频段规划和频谱分配，避免频谱干扰和冲突。</p>
                    </div>
                    <div class="img">
                        <img src="@/assets/solution/cehui/radio1.png" alt="">
                    </div>
                    <div>
                        <h4>无线电干扰监测</h4>
                        <p>
                            无线电监测可以用于检测和识别无线电信号的干扰源。当出现无线电干扰时，通过监测信号的频率、强度、调制方式等特征，可以确定干扰源的位置和类型，及时采取干扰抑制措施，保障正常通信服务的稳定性和可靠性。</p>
                    </div>
                    <div class="img">
                        <img src="@/assets/solution/cehui/radio2.png" alt="">
                    </div>
                    <div>
                        <h4>电磁环境监测</h4>
                        <p>
                            无线电监测可以用于对电磁环境进行监测和评估。通过对周围环境中的无线电信号进行监测，可以得到电磁辐射强度、频率分布等数据，评估电磁辐射对人体健康和环境的影响，为相关政策制定和环境保护提供科学依据。</p>
                    </div>
                    <div class="img">
                        <img src="@/assets/solution/cehui/radio3.png" alt="">
                    </div>
                    <div>
                        <h4>无线电通信安全</h4>
                        <p>
                            无线电监测可以用于保障无线电通信的安全性。通过监测无线电信号的频谱活动情况，可以发现非法窃听、窃取信息等安全威胁，及时采取对策，防止信息泄露和通信被攻击。</p>
                    </div>
                    <div class="img">
                        <img src="@/assets/solution/cehui/radio4.png" alt="">
                    </div>
                    <div>
                        <h4>边境管控与执法</h4>
                        <p>
                            无线电监测可以用于边境管控和执法行动。通过监测边境地区的无线电信号，可以发现非法越境、走私、通信黑点等违法活动，协助执法部门加强边境安全管理和打击犯罪行为。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
            const text = this.$refs.text;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        text.classList.add('animate__animated', 'animate__fadeInLeft');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(text);
        })
        this.$nextTick(() => {
            const img = this.$refs.img;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        img.classList.add('animate__animated', 'animate__fadeInRight');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(img);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import '../../../styles/spectrum/radioMonitoring';

</style>
